export const isNoFurtherInThePastThan = (
  date: Date,
  timeDifference: number
): boolean => {
  const now: number = new Date().getTime();
  const dateToCheck: number = date.getTime();
  return timeDifference > now - dateToCheck;
};

export const ONE_MINUTE: number = 1000 * 60;
export const ONE_HOUR: number = ONE_MINUTE * 60;
export const TWENTY_FOUR_HOURS: number = ONE_HOUR * 24;
export const SEVEN_DAYS: number = TWENTY_FOUR_HOURS * 7;
export const THIRTY_DAYS: number = TWENTY_FOUR_HOURS * 30;
export const SIX_MONTHS: number = THIRTY_DAYS * 6;

export const DATE_FORMAT_LONG = 'dd.MM.yyyy, HH:mm';
export const DATE_FORMAT = 'dd.MM.yyyy';
export const TIME_FORMAT_SHORT = 'HH:mm';
export const TIME_FORMAT = 'HH:mm:ss';
